import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'Aisha M.',
  location: 'Egypt',
  time: '2 min ago'
}, {
  name: 'Sarah K.',
  location: 'South Africa',
  time: '5 min ago'
}, {
  name: 'Priya S.',
  location: 'India',
  time: '8 min ago'
}, {
  name: 'Maria C.',
  location: 'Philippines',
  time: '12 min ago'
}, {
  name: 'Nadia R.',
  location: 'Pakistan',
  time: '15 min ago'
}, {
  name: 'Fatima A.',
  location: 'Nigeria',
  time: '18 min ago'
}, {
  name: 'Linh N.',
  location: 'Vietnam',
  time: '22 min ago'
}, {
  name: 'Siti A.',
  location: 'Indonesia',
  time: '25 min ago'
}, {
  name: 'Grace O.',
  location: 'Kenya',
  time: '30 min ago'
}, {
  name: 'Tariq M.',
  location: 'Bangladesh',
  time: '35 min ago'
}, {
  name: 'Elena V.',
  location: 'Ukraine',
  time: '40 min ago'
}, {
  name: 'Ana M.',
  location: 'Croatia',
  time: '45 min ago'
}, {
  name: 'Emily R.',
  location: 'Canada',
  time: '50 min ago'
}, {
  name: 'Jessica T.',
  location: 'Philippines',
  time: '1 hour ago'
}, {
  name: 'Chloe S.',
  location: 'South Africa',
  time: '1 hour ago'
}];
export function PurchasePopup() {
  const [currentBuyer, setCurrentBuyer] = useState<(typeof buyers)[0] | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    let buyerIndex = 0;
    const initialTimeout = setTimeout(() => {
      if (!dismissed) {
        setCurrentBuyer(buyers[buyerIndex]);
        setIsVisible(true);
        setTimeout(() => setIsVisible(false), 4500);
        buyerIndex++;
      }
    }, 10000);
    const interval = setInterval(() => {
      if (!dismissed && buyerIndex < buyers.length) {
        setCurrentBuyer(buyers[buyerIndex]);
        setIsVisible(true);
        setTimeout(() => setIsVisible(false), 4500);
        buyerIndex = (buyerIndex + 1) % buyers.length;
      }
    }, 30000 + Math.random() * 20000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, [dismissed]);
  if (dismissed) return null;
  return <AnimatePresence data-id="element-360">
      {isVisible && currentBuyer && <motion.div initial={{
      x: -320,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -320,
      opacity: 0
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-[85px] md:bottom-6 left-4 z-50 max-w-[300px] md:max-w-[340px]" data-id="element-361">
          <div className="bg-linen/95 backdrop-blur-sm rounded-lg border border-copper/15 px-4 py-2.5 flex items-center gap-3 cursor-pointer" onClick={() => {
        setIsVisible(false);
        setDismissed(true);
      }} data-id="element-362">
            <span className="text-base flex-shrink-0" data-id="element-363">🧶</span>
            <p className="text-xs text-deep-brown leading-snug" data-id="element-364">
              <span className="font-bold" data-id="element-365">{currentBuyer.name}</span> from{' '}
              {currentBuyer.location} got the breed patterns collection ·{' '}
              <span className="text-gray-400" data-id="element-366">{currentBuyer.time}</span>
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}